import script from "./sendEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./sendEmail.vue?vue&type=script&setup=true&lang=js"

import "./sendEmail.vue?vue&type=style&index=0&id=3dc5d34b&lang=scss&scoped=true"
import "./sendEmail.vue?vue&type=style&index=1&id=3dc5d34b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dc5d34b"]])

export default __exports__